/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown>, target: NonNullable<unknown>, scope: NonNullable<unknown> }} Task_Catalog_Issue_TargetInputs */

const en_task_catalog_issue_target = /** @type {(inputs: Task_Catalog_Issue_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} creates ${i?.target}, which is not available in ${i?.scope}.`)
};

const pt_br2_task_catalog_issue_target = /** @type {(inputs: Task_Catalog_Issue_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} cria ${i?.target}, que não está disponível em ${i?.scope}.`)
};

/**
* | output |
* | --- |
* | "{task} creates {target}, which is not available in {scope}." |
*
* @param {Task_Catalog_Issue_TargetInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_issue_target = /** @type {((inputs: Task_Catalog_Issue_TargetInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Issue_TargetInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_issue_target(inputs)
	return pt_br2_task_catalog_issue_target(inputs)
});